import React from 'react';

import { inject, observer } from 'mobx-react';

import { getChildInject } from '@/utils/instantLoaded/tools';
import { dispatchTrack, chatbotTrackObj } from '@/utils/tracking';
import { TRACKING_OPERATION, TRACKING_SECTION, TRACKING_TARGET, TRACKING_TYPE } from '@/utils/constants';
import { exitTrack } from '@/utils/tracking/utils/exitTrack';
import backImage from '@/assets/img/back_arrow.svg';

import { Avatar } from '@/components/loadFirstScreen';
import { isBank } from '@/config/core';
import bankBackImage from '@/assets/img/sea_bank_back_arrow.svg';
import coreStore from '@/stores/core';

const trackingname = TRACKING_TYPE.BACK;

function Navbar() {

  // 埋点用 - 点击事件
  const trackingHandler = () => {
    dispatchTrack({
      operation: TRACKING_OPERATION.CLICK,
      section: TRACKING_SECTION[trackingname],
      target: TRACKING_TARGET[trackingname],
    });
  };

  const handleExit = () => {
    // 点击埋点
    trackingHandler();
    exitTrack();
    chatbotTrackObj.flush();

    // 推出当前页面
    window.bridgeCallHandler('popWebView', {}, function () { });
  };

  const { botNickname } = coreStore.safeGetStore('initStore');
  const imageSrc = isBank() ? bankBackImage : backImage;

  return (
    <div className="custom-navbar">
      <div className="back-icon" onClick={handleExit}>
        <img src={imageSrc} />
      </div>
      <div className="content">
        <>
          <Avatar from="bot" />
          <div className="title">{botNickname}</div>
        </>
      </div>
    </div>
  );
}

export default inject(getChildInject())(observer(Navbar));
